import { useEffect, useState, MouseEvent, useContext } from 'react'
import { FragmentProps, FragmentType } from '../../../interfaces/Publication';
import { ReferencesContext } from '../../../context';

const CONTENT = ({ fragment, openButtons, setOpenButtons }: FragmentProps) => {
    return (
        <div>ESTE ES EL CONTENTENIDO DE LA REVISTA</div>
    )
}

export default CONTENT